import { SelectionGroupOption } from 'common/components';
import { Solution } from '../solution-card';

export const LIVING_ROOM_SOLUTION_TAB_LIST: SelectionGroupOption[] = [
  { value: '1', text: 'Низкая перегородка' },
  { value: '2', text: 'Тумба и полки' },
  { value: '3', text: 'Комплект стеллажей' },
  { value: '4', text: 'Высокая перегородка' },
];

export const LIVING_ROOM_SOLUTION_CONTENT_MAP: Record<string, Solution> = {
  '1': {
    imgSrc:
      'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/spaceo-storage/decision/2-1.jpg/2-1.jpg',
    imgAlt: 'Низкая перегородка',
    title: 'Низкая перегородка',
    size: '144 × 93,6 × 32 см',
    productIds: [
      '82731882',
      '82731875',
      '82731878',
      '82005978',
      '82020863',
      '82020864',
      '82731887',
      '82731898',
      '82731907',
    ],
    '82731882': {
      productCount: 1,
    },
    '82731875': {
      productCount: 2,
    },
    '82731878': {
      productCount: 1,
    },
    '82005978': {
      productCount: 4,
    },
    '82020863': {
      productCount: 1,
    },
    '82020864': {
      productCount: 3,
    },
    '82731887': {
      productCount: 2,
    },
    '82731898': {
      productCount: 1,
    },
    '82731907': {
      productCount: 2,
    },
    totalUrlLabel: 'spaceo-kub-komplekt-gostinaya-nizkaya-peregorodka',
  },
  '2': {
    imgSrc:
      'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/spaceo-storage/decision/2-2.jpg/2-2.jpg',
    imgAlt: 'Тумба и полки',
    title: 'Тумба и полки',
    size: 'Тумба: 144 × 57,6 × 32 см; полки: 144 × 108 × 32 см',
    productIds: [
      '82731882',
      '82731875',
      '82731908',
      '82731878',
      '82731910',
      '82005978',
      '82020863',
      '82020864',
      '82731904',
      '82731901',
      '82731905',
      '82036412',
    ],
    '82731882': {
      productCount: 1,
    },
    '82731875': {
      productCount: 2,
    },
    '82731908': {
      productCount: 3,
    },
    '82731878': {
      productCount: 1,
    },
    '82731910': {
      productCount: 1,
    },
    '82005978': {
      productCount: 1,
    },
    '82020863': {
      productCount: 1,
    },
    '82020864': {
      productCount: 3,
    },
    '82731904': {
      productCount: 4,
    },
    '82731901': {
      productCount: 1,
    },
    '82731905': {
      productCount: 1,
    },
    '82036412': {
      productCount: 7,
    },
    totalUrlLabel: 'spaceo-kub-komplekt-gostinaya-tumba-i-polki',
  },
  '3': {
    imgSrc:
      'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/spaceo-storage/decision/2-3.jpg/2-3.jpg',
    imgAlt: 'Комплект стеллажей',
    title: 'Комплект стеллажей',
    size: '144 × 144 × 32 см',
    productIds: ['82731875', '82731909', '82731878', '82731904', '82036412'],
    '82731875': {
      productCount: 3,
    },
    '82731909': {
      productCount: 4,
    },
    '82731878': {
      productCount: 9,
    },
    '82731904': {
      productCount: 3,
    },
    '82036412': {
      productCount: 16,
    },
    totalUrlLabel: 'spaceo-kub-komplekt-gostinaya-komplekt-stellazhey',
  },
  '4': {
    imgSrc:
      'https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/spaceo-storage/decision/2-4.jpg/2-4.jpg',
    imgAlt: 'Высокая перегородка',
    title: 'Высокая перегородка',
    size: '180 × 162 × 32 см',
    productIds: ['82731915', '82731869', '82005978', '82731890', '82010844', '82731906'],
    '82731915': {
      productCount: 17,
    },
    '82731869': {
      productCount: 11,
    },
    '82005978': {
      productCount: 11,
    },
    '82731890': {
      productCount: 3,
    },
    '82010844': {
      productCount: 4,
    },
    '82731906': {
      productCount: 5,
    },
    totalUrlLabel: 'spaceo-kub-komplekt-gostinaya-vysokaya-peregorodka',
  },
};
